import React from "react";
import { ReactComponent as GroupIcon } from "assets/img/icons/netThrivingLogo.svg";
import * as moment from "moment";

const styles = {
  heading: {
    fontWeight: 300,
  },
  value: {
    fontWeight: 500,
  },
  leftValue: {
    fontWeight: 500,
    margin: "0 0px 0 5px",
  },
};

export default ({ stats }) => {
  const classes = styles;

  return (
    <>
      {stats && stats?.happiness_meter >= 0 && (
        <div className="netThrivingHeaderRoot">
          <div className="netThrivingHeader">
            <span>
              <GroupIcon />
            </span>
            <span className="netTeamName">{stats?.name}</span>
          </div>
          <div className="netThrivingContent">
            <div className="netThrivingLeftContent">
              <div>
                <span style={classes.heading}>Net Thriving Score</span>
                <span style={classes.leftValue}>
                  {stats?.net_thriving_score}
                </span>
              </div>
              <div>
                <span style={classes.heading}>Happiness Meter</span>
                <span style={classes.leftValue}>{stats?.happiness_meter}%</span>
              </div>
            </div>
            <div className="netThrivingRightContent">
              <span style={classes.heading}>Last Team Idea</span>
              <span style={classes.value}>
                {!moment(stats?.last_team_brightidea).isValid()
                  ? "N/A"
                  : moment(stats?.last_team_brightidea).format("MMM D, YYYY")}
              </span>
              <span style={classes.heading}>Last Check-in</span>
              <span style={classes.value}>
                {!moment(stats?.last_team_checkin).isValid()
                  ? "N/A"
                  : moment(stats?.last_team_checkin).format("MMM D, YYYY")}
              </span>
              <span style={classes.heading}>Last Wall of Fame</span>
              <span style={classes.value}>
                {!moment(stats?.last_celebration).isValid()
                  ? "N/A"
                  : moment(stats?.last_celebration).format("MMM D, YYYY")}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
